import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface UseSyncDetailRowToUrlArgs {
  rows: any[];
  dataKey: string;
  expandedRow: any;
  setExpandedRow: (row: any) => void;
  setCurrentSelectedRowIndex: (index: number) => void;
}

// Sync URL -> expandedRow + currentSelectedRowIndex on browser back/forward.
// Paginator push changes URL ahead of state; back/forward must reflect URL itemId.
// Detail's debounced data-rows effect gives precedence to expandedRow, so
// without this effect the URL reverts but the rendered row stays the old one.
export const useSyncDetailRowToUrl = ({
  rows,
  dataKey,
  expandedRow,
  setExpandedRow,
  setCurrentSelectedRowIndex,
}: UseSyncDetailRowToUrlArgs): void => {
  const { itemId } = useParams<{ itemId: string }>();

  useEffect(() => {
    if (!itemId || !rows?.length || !dataKey) return;
    // Paginator already set expandedRow before pushing URL — skip.
    if (expandedRow && String(expandedRow[dataKey]) === String(itemId)) return;

    const idx = rows.findIndex(
      (row: any) => String(row[dataKey]) === String(itemId)
    );
    if (idx >= 0) {
      setCurrentSelectedRowIndex(idx);
      setExpandedRow(rows[idx]);
    }
  }, [itemId]);
};
